module.exports = __webpack_public_path__ + "img/tooltip3.15ba1fda.svg";